import { inject, Injectable } from '@angular/core';
import { CoreService } from '@core-session';
import { Currency } from '@data-access';

@Injectable({ providedIn: 'root' })
export class CurrencyService {
  protected coreService = inject(CoreService);

  resolveCurrency(currency?: Currency | null): Currency {
    return currency ?? this.coreService.getCurrency() ?? Currency.Usd;
  }
}
